module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAAwUlEQVQ4T2NkIBEwIqt/t0qJn+MfcwJXxO2JuMxB0fBtucqB////2zMyMEzkirpbgE0TioYfy5Q9/jEwrP/PwMCBSxOKBpCJhDRhaCCkCasGfJpwagBp+r5MOf4fA8MCEJuRgaGEK+puL04NXxfLSzKxMO/7959Rg4GB8QIXyw9nxrAn77BqwKUYahNqaONTjKGBkGIMDd+WK534/5/RHNnN6LGN4odfSxXN/jAxdXIy/wwGeZBg0iAm4eKNB2wGAAAVb2MR+Y7lyAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qximg/wwf.png
// module id = 6mOu
// module chunks = 1